<template>
  <div class="body">
    <!-- 签收扫描 -->
    <baseBreadcrumb :page="$t('message.SignInScan')" :menu="$t('message.followUpTheReplacementPackage')" />
    <div class="body">
      <div class="search">
        <!-- 订单号 -->
        <div class="item">
          <el-input v-model="datas.order_sn" :placeholder="$t('message.orderNumber')"></el-input>
        </div>
        <!-- 交易号 -->
        <div class="item">
          <el-input v-model="datas.purchase_no" :placeholder="$t('message.transactionNumber')"></el-input>
        </div>

        <!-- 退换货物流号 -->
        <div class="item">
          <el-input v-model="datas.refund_express_no"
            :placeholder="$t('message.returnAndExchangeLogisticsNumber')"></el-input>
        </div>
        <!-- 开始日期 -->
        <div class="item">
          <el-date-picker v-model="datas.dateStart" type="datetime" :placeholder="$t('message.startDate')"
            default-time="['00:00:00']" value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </div>
        <!-- 结束日期 -->
        <div class="item">
          <el-date-picker v-model="datas.dateEnd" type="datetime" :placeholder="$t('message.dateClosed')"
            default-time="['23:59:59']" value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </div>
        <!-- 采购员 -->
        <div class="item">
          <el-select v-model="datas.g_id" clearable filterable :placeholder="$t('message.buyer')">
            <el-option v-for="item in g" :key="item.id" :label="item.realname" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <!-- 配货员 -->
        <div class="item">
          <el-select v-model="datas.p_id" clearable filterable :placeholder="$t('message.distributionMember')">
            <el-option v-for="item in p" :key="item.id" :label="item.realname" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <!-- 退换货类别 -->
        <div class="item">
          <el-select v-model="datas.refund_type" clearable :placeholder="$t('message.returnAndExchange')">
            <el-option label="退货" value="1"></el-option>
            <el-option label="换货" value="2"></el-option>
          </el-select>
        </div>
        <!-- 按钮 -->
        <div class="item">
          <!-- 筛选 -->
          <el-button type="primary" @click="search">{{
            $t("message.filter")
          }}</el-button>
          <!-- <el-button @click="reset">{{ $t("message.reset") }}</el-button> -->
        </div>
      </div>
      <div class="table">
        <el-table :data="tableData" :default-sort="{ prop: 'date', order: 'descending' }"
          :header-cell-style="{ background: '#EDEFF4' }" style="width: 100%" ref="multipleTable" v-if="show">
          <el-table-column align="center" label="NO" prop="rowNumber" width="60">
          </el-table-column>

          <!--  退换货编号-->
          <el-table-column align="center" :label="$t('message.returnAndExchangeNumber')" prop="refund_sn" width="150px">
          </el-table-column>
          <!-- 退件扫描时间 -->
          <el-table-column align="center" :label="$t('message.returnScanTime')" prop="scan_at" width="100">
            <template slot-scope="scope">
              {{ scope.row.order_purchase_refund_detail[0] &&
                scope.row.order_purchase_refund_detail[0].order_purchase_refund_detail_express[0]
                ? scope.row.order_purchase_refund_detail[0].order_purchase_refund_detail_express[0].scan_at
                : '' }}
            </template>
          </el-table-column>
          <!--  打包时间-->
          <el-table-column align="center" :label="$t('message.packingTimeDB')" prop="pack_at" width="100px">
          </el-table-column>
          <!-- 打印时间 -->
          <el-table-column align="center" :label="$t('message.printTime')" prop="action_packed_at" width="100px">
          </el-table-column>
          <!--  提出时间-->
          <el-table-column align="center" :label="$t('message.forwardTime')" prop="created_at" width="100px">
          </el-table-column>
          <!--  采购员-->
          <el-table-column align="center" :label="$t('message.buyer')" prop="g_admin.realname" width="100">
          </el-table-column>
          <!--  配货员-->
          <el-table-column align="center" :label="$t('message.distributionMember')" prop="p_admin.realname" width="100">
          </el-table-column>
          <!--  订单号-->
          <el-table-column align="center" :label="$t('message.orderNumber')" prop="" width="170px">
            <template slot-scope="scope">
              <p>
                <router-link :to="'/orderPaymentDetail?order_sn=' + scope.row.order_sn" target="_blank"
                  style="color: #fa5058">{{ scope.row.order_sn }}</router-link>
              </p>
              <!-- <p>
                {{
                  scope.row.order_purchase_refund_detail.order_purchase.realname
                }}
              </p> -->
            </template>
          </el-table-column>
          <!--  交易号-->
          <el-table-column align="center" :label="$t('message.transactionNumber')" prop="purchase_no">
          </el-table-column>
          <!--  退换货类别-->
          <el-table-column align="center" :label="$t('message.typeOfReturnOrExchange')" prop="type_name" width="110px">
            <template slot-scope="scope">
              <span :style="{
                color: scope.row.refund_type == 1 ? '#FA5058' : '#2C96E7',
              }">{{ scope.row.type_name }}</span>
              <span v-if="scope.row.is_direct_complete == 1" class="direct-complete-tag">
                {{ $t("message.completeDirectly") }}
              </span>
            </template>
          </el-table-column>
          <!--  退换货数量-->
          <el-table-column align="center" :label="$t('message.quantityOfReturnAndReplacement')" prop="refund_num_total"
            width="110px">
          </el-table-column>
          <!--  商品明细-->
          <el-table-column align="center" :label="$t('message.detailsOfGoods')" prop="rowNumber">
            <template slot-scope="scope">
              <el-button size="mini" type="success" @click="look(scope.row)">{{
                $t("message.look")
              }}</el-button>
            </template>
          </el-table-column>
          <!--  退换货物流号-->
          <el-table-column align="center" :label="$t('message.returnAndExchangeLogisticsNumber')" prop="rowNumber"
            width="200">
            <template slot-scope="scope">
              <div class="template">
                <div v-for="(express, expressIndex) in scope.row
                  .order_purchase_refund_detail_express" :key="expressIndex">
                  <div>
                    <el-popover placement="left" title="国内物流:" width="400" trigger="click">
                      <el-timeline v-if="activities != false">
                        <el-timeline-item v-for="(activity, index) in activities" :key="index" :timestamp="activity.time"
                          :color="activity.color" placement="top">
                          {{ activity.context }}
                        </el-timeline-item>
                      </el-timeline>
                      <p v-else> 暂无物流信息 </p>
                      <p slot="reference">
                        <span class="WL">
                          <a href="javascript:;" class="a-link" @click="getTrace
                            (express.refund_express_no)"> {{ express.refund_express_no }}</a>
                          <i class="el-icon-copy-document" @click.stop="copy(express.refund_express_no)"></i></span>
                      </p>
                    </el-popover>
                  </div>
                  {{ express.scan_at }}
                </div>
              </div>
            </template>
          </el-table-column>
          <!-- 直接完成说明 -->
          <el-table-column align="center" :label="$t('message.directCompleteDescription')"
            prop="direct_complete_remark" width="160">
          </el-table-column>
          <!-- 直接完成凭证 -->
          <el-table-column align="center" :label="$t('message.directCompleteProof')" prop="direct_complete_proof"
            width="180">
            <template slot-scope="scope">
              <a v-for="(url, proofIndex) in scope.row.direct_complete_proof" :key="proofIndex" :href="url"
                target="_blank" rel="noopener noreferrer" class="proof-link">
                {{ getProofFileName(url) }}
              </a>
            </template>
          </el-table-column>
        </el-table>

      </div>
      <!-- 分页 -->
      <div class="paginationContainer">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="datas.page"
          :page-sizes="[10, 20, 50, 100]" :page-size="datas.pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
    <!-- 查看商品详情 -->
    <detailsGoodsDialogVisible :list="itemData" v-if="detailsGoodsDialogVisible" />
  </div>
</template>
<script>
import detailsGoodsDialogVisible from "../components/goodsDetails";

export default {
  data() {
    return {
      activities: [],
      tableData: [],
      show: true,
      datas: {
        page: 1,
        pageSize: 10,
        status: 13,
        order_sn: "",
        purchase_no: "",
        g_id: "",
        p_id: "",
        refund_type: "",
        dateStart: "",
        dateEnd: "",
      },
      total: 0,
      detailsGoodsDialogVisible: false,

      itemData: [],
    };
  },
  components: {
    detailsGoodsDialogVisible,
  },
  computed: {
    g() {
      return this.$store.state.authWorkGroupAdmin.g;
    },
    p() {
      return this.$store.state.authWorkGroupAdmin.p;
    },
  },
  created() {
    this.refundList();
  },
  methods: {
    refundList() {
      this.$api.signInApi.refundList(this.datas).then((res) => {
        res.data.data.forEach((item) => {
          item.order_purchase_refund_detail_express = [];

          item.order_purchase_refund_detail.forEach((items) => {
            item.order_purchase_refund_detail_express = [
              ...item.order_purchase_refund_detail_express,
              ...items.order_purchase_refund_detail_express,
            ];
          });
        });
        this.tableData = res.data.data;
        this.total = res.data.total;
        console.log(this.tableData);
      });
    },
    // 搜索
    search() {
      this.datas.page = 1;
      this.refundList();
    },
    // 重置
    reset() {
      this.datas = {
        page: 1,
        pageSize: 10,
        status: 13,
        order_sn: "",
        purchase_no: "",
        g_id: "",
        p_id: "",
        refund_type: "",
        dateStart: "",
        dateEnd: "",
      };
      this.refundList();
    },
    // 分页
    handleCurrentChange(val) {
      this.datas.page = val;
      this.refundList();
    },
    handleSizeChange(val) {
      this.datas.pageSize = val;
      this.refundList();
    },
    // 查看
    look(item) {
      this.itemData = JSON.parse(
        JSON.stringify(item.order_purchase_refund_detail)
      );
      this.detailsGoodsDialogVisible = true;
    },
    // 凭证链接展示 OSS 原文件名
    getProofFileName(url) {
      const fileName = url.split("/").pop().split("?")[0];
      try {
        return decodeURIComponent(fileName);
      } catch (error) {
        return fileName;
      }
    },
    //快递100物流轨迹-查询
    getTrace(expressNo) {
      this.$api.getTrace({ expressNo }).then(res => {
        if (res.data != false) {
          res.data.trace[0].color = '#B4272D'
        }
        this.activities = res.data.trace
      })
    },
  },
};
</script>
<style lang='scss' scoped>
.search {
 
  display: flex;
  flex-wrap: wrap;

  .item {
    width: 200px;
    margin-right: 24px;
    margin-bottom: 24px;
    /deep/.el-date-editor {
      width:200px;
    }
  }
}

.table {
  .direct-complete-tag {
    display: block;
    width: fit-content;
    margin: 6px auto 0;
    padding: 2px 5px;
    border-radius: 4px;
    color: #fff;
    background-color: #f20c35;
    line-height: 20px;
  }

  .proof-link {
    display: block;
    color: #2c96e7;
    text-decoration: underline;
    word-break: break-all;
  }

  p {
    margin-bottom: 5px;

    .el-button {
      width: 80px;
    }
  }

  .primary {
    padding: 9px 0;
  }
}
</style>
